import {ProjectGanttViewModule} from './../../../widgets/project-gantt-view/project-gantt-view.module';
import {ConfirmationPopUpModule} from './../../../widgets/confirmation-pop-up/confirmation-pop-up.module';
import {InfoHeaderModule} from 'src/app/widgets/info-header/info-header.module';
import {TaskPopupModule} from './../../task/task-popup/task-popup.module';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxDataGridModule, DxChartModule, DxTextAreaModule, DxPopupModule, DxButtonModule, DxDropDownButtonModule, DxGanttModule, DxLookupModule, DxCircularGaugeModule, DxPivotGridModule} from 'devextreme-angular';
import {DevEpressCommonModule} from 'src/app/dev-epress-common.module';
import {TaskListPopupModule} from '../../task/task-list-popup/task-list-popup.module';
import {ProjectDeepDiveComponent} from './project-deep-dive.component';
import {ProjectDeepDiveRoutingModule} from './project-deep-dive-routing.module';
import {ProjectService} from '../project.service';
import {FiltersGroupModule} from 'src/app/widgets/filters/filters-group/filters-group.module';
import {BookmarkNewComponent} from 'src/app/widgets/bookmark-new/bookmark-new.component';
import {HelpButtonComponent} from 'src/app/widgets/help-button/help-button.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { ContainerComponent } from 'src/app/components/container/container.component';

@NgModule({
	declarations: [ProjectDeepDiveComponent],
	imports: [
		CommonModule,
		ProjectDeepDiveRoutingModule,
		DxDataGridModule,
		DxChartModule,
		DevEpressCommonModule,
		DxTextAreaModule,
		DxButtonModule,
		DxPopupModule,
		DxGanttModule,
		DxDropDownButtonModule,
		TaskPopupModule,
		BookmarkNewComponent,
		HelpButtonComponent,
		TaskListPopupModule,
		InfoHeaderModule,
		ConfirmationPopUpModule,
		DxLookupModule,
		DxCircularGaugeModule,
		FiltersGroupModule,
		DxPivotGridModule,
		ProjectGanttViewModule,
		ContainerComponent,
		DxTableControllerDirective,
	],
	providers: [ProjectService],
})
export class ProjectDeepDiveModule {}
